import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-six-section',
  templateUrl: './explore-six-section.component.html',
  styleUrls: ['./explore-six-section.component.scss']
})
export class ExploreSixSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
